var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_155_24709)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 11.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 1.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 1.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 1.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 1.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 7.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 8.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 10,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 11.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 17.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 17.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 17.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 17.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 16.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 16.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 2.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 10,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 8.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 7.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 2.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 6.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 6.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 12.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 12.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 2.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 2.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 13.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 16.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 16.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 3.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 3.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 15,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 13.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 13.75,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 15,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 16.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 16.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 13.75,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 12.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 11.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 7.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 3.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 2.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 2.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 3.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 6.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 7.5,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 8.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 10,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 11.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 12.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 13.75,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 15,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 16.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 15,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 13.75,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 12.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 11.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 10,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 8.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 7.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 6.25,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 3.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 3.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 6.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 7.5,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 8.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 10,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 11.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 12.5,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 13.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 15,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 13.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 12.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 11.25,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 10,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 8.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 7.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 6.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 7.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 8.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 10,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 11.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 2.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 3.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 6.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 7.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 8.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 10,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 11.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 12.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 12.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 13.75,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 15,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 16.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 15,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 13.75,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 12.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 11.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 10,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 8.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 7.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 6.25,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 3.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 3.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 6.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 7.5,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 8.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 10,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 11.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 2.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 7.5,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 11.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 12.5,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 13.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 15,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 13.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 12.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 11.25,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 10,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 8.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 7.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 6.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 7.5,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 8.75,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 10,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 11.25,
    width: 1.25,
    height: 1.25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 18.75,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    y: 18.75,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 18.75,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 18.75,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 17.5,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 17.5,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 16.25,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 15,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 13.75,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 12.5,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.75,
    y: 11.25,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.75,
    y: 10,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.75,
    y: 8.75,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.75,
    y: 7.5,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 6.25,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 5,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 3.75,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 2.5,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 1.25,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 1.25,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.75,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 1.25,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 1.25,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 2.5,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 3.75,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 5,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 6.25,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 7.5,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 8.75,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 10,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 11.25,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 12.5,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 13.75,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 16.25,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 15,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17.5,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 17.5,
    width: 1.25,
    height: 1.25,
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_155_24709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGood);
export default __webpack_public_path__ + "static/media/Good.cace673b874c19a4db45268c007d09d9.svg";
export { ForwardRef as ReactComponent };